import { db } from "../../data/base";
import { collection, doc, getDocs, getDoc, updateDoc, setDoc, addDoc, query, where } from "firebase/firestore";

export const fetchAllMaterialPresets = async () => {
    let materialPresets = [];
    try {
        const querySnapshot = await getDocs(collection(db, "MaterialPresets"));
        querySnapshot.forEach((doc) => {
            const presetData = { id: doc.id, ...doc.data() }
            materialPresets.push(presetData); // Add each preset to the array
        });

        return materialPresets;

    } catch (err) {
        console.error("Error when fetching material presets: ", err);
        throw err;
    }
}

export const fetchModelMaterialPresets = async (modelData) => {
    let presetsMap = new Map();
    try {
        // Recuperiamo tutti i documenti referenziati
        const promises = modelData.list_material_presets.map(async (preset) => {
            try {
                const docSnap = await getDoc(doc(db, "MaterialPresets", preset.materialPreset));
                if (docSnap.exists()) {
                    const presetData = { id: docSnap.id, ...docSnap.data(), materialName: preset.materialName };
                    return presetData;
                } else {
                    console.warn(`Material preset not found: ${preset.materialPreset}`);
                    return null;
                }
            } catch (error) {
                console.error(`Failed to fetch the material preset ${preset.materialPreset}:`, error);
                return null;
            }
        });

        // Aspettiamo che tutte le richieste siano completate
        const resolvedPresets = await Promise.all(promises);

        // Filtriamo eventuali preset non trovati e li aggiungiamo alla mappa
        resolvedPresets
            .filter(p => p !== null && p.materialName)
            .forEach(preset => {
                presetsMap.set(preset.materialName, preset);
            });

        // Ora abbiamo una mappa di oggetti materialPreset con materialName come chiave
        // console.log("Material presets map:", presetsMap);

        return presetsMap;
    } catch (err) {
        console.error("Error when fetching material presets: ", err);
        throw err;
    }
}

export const updateModelMaterialPresets = async (modelId, materialPresetsMap) => {
    try {
        const modelDocRef = doc(collection(db, "Modello"), modelId);
        const modelData = await getDoc(modelDocRef);
        
        if (modelData.exists()) {
            // Convert the map to an array of objects with material name and preset id
            const presetsList = Array.from(materialPresetsMap.entries()).map(([materialName, preset]) => ({
                materialName,
                materialPreset: preset.id
            }));
            
            await updateDoc(modelDocRef, { 
                list_material_presets: presetsList 
            });
        }
    } catch (error) {
        console.error("Error when updating model material presets: ", error);
        throw error;
    }
}

export const storeMaterialPreset = async (materialPreset) => {
    try {
        // 1. Query per vedere se esiste già un preset con lo stesso nome
        const presetsRef = collection(db, "MaterialPresets");
        const q = query(presetsRef, where("name", "==", materialPreset.name));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            // 2. Esiste già: aggiorna il primo documento trovato
            const docId = querySnapshot.docs[0].id;
            const docRef = doc(db, "MaterialPresets", docId);
            await setDoc(docRef, materialPreset, { merge: true }); // merge: true aggiorna solo i campi passati
        } else {
            // 3. Non esiste: crea nuovo documento (ID generato da Firestore)
            await addDoc(presetsRef, materialPreset);
        }
    } catch (error) {
        console.error("Error when setting material preset: ", error);
        throw error;
    }
}